export default __webpack_public_path__ + "static/media/google-login.5478be96.svg";